export default __webpack_public_path__ + "static/media/logoPrimary.536be8ed.png";